import { render, staticRenderFns } from "./userInfoWelcome.vue?vue&type=template&id=e00ba202&scoped=true&"
import script from "./userInfoWelcome.vue?vue&type=script&lang=js&"
export * from "./userInfoWelcome.vue?vue&type=script&lang=js&"
import style0 from "./userInfoWelcome.vue?vue&type=style&index=0&id=e00ba202&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e00ba202",
  null
  
)

export default component.exports